module.exports = __webpack_public_path__ + "static/media/summary_06.40859d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/news/images/summary_06.png
// module id = 1207
// module chunks = 0